function file_download_track (form, userId) {


	try {
    const customerEmail = atob(form.querySelector('[name="customer_email"]').value);
    const customerId    = atob(form.querySelector('[name="customer_id"]').value);
    const customerName  = atob(form.querySelector('[name="customer_name"]').value);
    const productId     = atob(form.querySelector('[name="product_id"]').value);
    const productName   = atob(form.querySelector('[name="product_name"]').value);
    const productUrl    = atob(form.querySelector('[name="product_url"]').value);

  // Here you can set the URL per specific user if you're testing new code
  //  if (customerId == 10141247602919) {
  //    url = 'https://apps.linia-presentations.com/backgrounds-apps/download-test.php';
  //  }

      url = 'https://apps.linia-presentations.com/backgrounds-apps/download-track.php';
      fetch(`${url}?customer_id=${customerId}&customer_name=${encodeURIComponent(customerName)}&customer_email=${encodeURIComponent(customerEmail)}&product_id=${productId}&product_name=${encodeURIComponent(productName)}&product_url=${encodeURIComponent(productUrl)}`)
        .catch(error => console.error('Logging failed:', error));

    } catch (error) {
      console.error('Logging customer download failed:', error);

  }

}